<template>
    <table class="w-100">
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.name') }}</label></td>
      <td>{{ details.name }}</td>
    </tr>
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.surname') }}</label></td>
      <td>{{ details.surname }}</td>
    </tr>
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.person_identifier') }}</label></td>
      <td><restricted-info :details="details.person_identifier"/></td>
    </tr>
      <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.relation') }}</label></td>
      <td>{{ details.relation }}</td>
    </tr>
    </table>
</template>
<script>
import RestrictedInfo from '../RestrictedInfo/RestrictedInfo'

export default {
  name: 'AccountAdditionalDetailsDataViewAssignee',
  components: {
    RestrictedInfo
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
